import React from "react";
import { Button } from "reactstrap";

import { AUTOPILOT_COLORS, autopilotInsetCardStyle } from "../../../components/autopilot/styles";
import ConectorLogo from "./ConectorLogo";
import { ROTULO_STATUS, STATUS } from "./statusDoConector";
import { rotuloCapacidade } from "./classificacao";

// Card do catálogo de conectores (H3, PO1-3261): logo em faixa no topo (ou sigla), nome,
// categoria, descrição curta, direção e badge de status. Mesmo padrão do
// CatalogoCard de Transportadoras (tudo por token; aberto = borda de destaque).
const TONS = {
  [STATUS.ATIVA]: { bg: AUTOPILOT_COLORS.statusSuccessBg, border: AUTOPILOT_COLORS.statusSuccessBorder, color: AUTOPILOT_COLORS.statusSuccess },
  [STATUS.DISPONIVEL]: { bg: AUTOPILOT_COLORS.insetSurface, border: AUTOPILOT_COLORS.border, color: AUTOPILOT_COLORS.muted },
  [STATUS.GERENCIADA]: { bg: AUTOPILOT_COLORS.insetSurface, border: AUTOPILOT_COLORS.statusInfo, color: AUTOPILOT_COLORS.statusInfo },
};

// `rotulo` (opcional) substitui o texto padrão do status: os cards do catálogo
// (H4) mostram a versão ("Ativa · v1.0") ou a troca agendada.
export function StatusConectorBadge({ status, rotulo }) {
  const tom = TONS[status] || TONS[STATUS.DISPONIVEL];
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        fontSize: "0.72rem",
        padding: "2px 8px",
        borderRadius: 10,
        whiteSpace: "nowrap",
        background: tom.bg,
        color: tom.color,
        border: `1px solid ${tom.border}`,
      }}
    >
      {rotulo || ROTULO_STATUS[status] || status}
    </span>
  );
}

// Etiquetas do que o conector troca (H4): os `cap_*` da versão nos cards do
// catálogo, ou a lista escrita em conectores.js nos 6 fixos.
export function CapacidadeTags({ capacidades }) {
  const lista = Array.isArray(capacidades) ? capacidades : [];
  if (!lista.length) return null;
  return (
    <div className="integracoes-tags" aria-label="O que troca">
      {lista.map((cap) => (
        <span key={cap} className="integracoes-tag">
          {rotuloCapacidade(cap)}
        </span>
      ))}
    </div>
  );
}

const cardStyle = {
  ...autopilotInsetCardStyle,
  padding: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
  cursor: "pointer",
  transition: "border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease",
};

const corpoStyle = {
  padding: "0.8rem 1rem 0.9rem",
  display: "flex",
  flexDirection: "column",
  gap: "0.55rem",
  flex: 1,
  minWidth: 0,
};

const cardAbertoStyle = {
  border: `1px solid ${AUTOPILOT_COLORS.accent}`,
  background: AUTOPILOT_COLORS.insetSurfaceActive,
  boxShadow: `inset 0 0 0 1px ${AUTOPILOT_COLORS.accent}, var(--everlog-card-active-glow)`,
};

const detalheButtonStyle = {
  background: "transparent",
  border: "1px solid var(--theme-accent-border)",
  color: AUTOPILOT_COLORS.accent,
  fontWeight: 600,
  boxShadow: "none",
  whiteSpace: "nowrap",
  padding: "0.45rem 0.6rem",
  flexShrink: 0,
  marginLeft: "auto",
};

export default function ConectorCard({ conector, status, rotuloStatus, aberto, onAbrir }) {
  const rotuloAcao = conector.gerenciado ? "Detalhes" : status === STATUS.ATIVA ? "Configurar" : "Ativar";
  return (
    <div
      className={`conector-card${aberto ? " is-open" : ""}`}
      style={{ ...cardStyle, ...(aberto ? cardAbertoStyle : null) }}
      onClick={onAbrir}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onAbrir();
        }
      }}
      aria-pressed={!!aberto}
    >
      <ConectorLogo conector={conector} variant="faixa" height={96} />

      <div style={corpoStyle}>
        <div style={{ minWidth: 0 }}>
          <div style={{ color: AUTOPILOT_COLORS.title, fontSize: "0.95rem", fontWeight: 600, lineHeight: 1.3 }}>{conector.nome}</div>
          <div style={{ color: AUTOPILOT_COLORS.muted, fontSize: "0.74rem", marginTop: 2 }}>
            {conector.categoria} · {conector.direcao}
          </div>
        </div>

        <div style={{ color: AUTOPILOT_COLORS.text, fontSize: "0.8rem", lineHeight: 1.5 }}>{conector.descricaoCurta}</div>

        <CapacidadeTags capacidades={conector.capacidades} />

        <div style={{ marginTop: "auto", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "0.5rem", flexWrap: "wrap" }}>
          <StatusConectorBadge status={status} rotulo={rotuloStatus} />
          <Button
            type="button"
            size="sm"
            style={detalheButtonStyle}
            onClick={(e) => {
              e.stopPropagation();
              onAbrir();
            }}
            title={`Abrir ${conector.nome}`}
          >
            {rotuloAcao}
          </Button>
        </div>
      </div>
    </div>
  );
}
